export const Version = {
	version: '1.43.1.4',
};
